<div class="rl">
  @if (updatedPhoneNumbers.length) {
  <p class="rl__intro">You edited these numbers. The new number is the one that will be added.</p>
  <ul class="rl__list">
    @for (updated of updatedPhoneNumbers; track $index) {
    <li class="phoneNumber rl__item rl__item--edit">
      <span class="number rl__meta rl__old">{{ updated.previous || '(empty)' }}</span>
      <span class="bk-sym rl__arrow" aria-hidden="true">arrow_forward</span>
      <span class="bk-sr-only">changed to</span>
      <span class="number rl__new">{{ updated.update }}</span>
    </li>
    }
  </ul>
  } @else {
  <div class="noUpdated rl__empty">
    <span class="bk-sym" aria-hidden="true">edit</span>
    <p class="rl__empty-title">No edits</p>
    <p class="rl__empty-body">
      To correct a number, go back to Check numbers and select it, or open the Invalid tab.
    </p>
  </div>
  }
</div>
